const anchor = document.querySelectorAll('.js-anchor');
const accordionItem = document.querySelectorAll('.js-accordion-item')
for(let i = 0; i < anchor.length; i ++){
  anchor[i].addEventListener("click", anchorSwitch);
}

function anchorSwitch(){
  document.querySelector('.is-anchor-active').classList.remove("is-anchor-active");
  this.classList.add("is-anchor-active");
  const anchorId = this.getAttribute("href").replace("#", "");
  for(let i = 0; i < accordionItem.length; i ++){
    const accordionItemId = accordionItem[i].getAttribute("id");
    if(anchorId == accordionItemId){
      const targetContent = accordionItem[i].querySelector('.accordion')
      targetContent.setAttribute("open", "");
    }else{
      const otherContent = accordionItem[i].querySelector('.accordion')
      otherContent.removeAttribute("open");
    }
  }
}

for(let i = 0; i < accordionItem.length; i ++){
  const targetElement = accordionItem[i]
  targetElement.addEventListener('click', (element) => {
    for(let i = 0; i < accordionItem.length; i ++){
      if (accordionItem[i] !== targetElement) {
        const otherContent = accordionItem[i].querySelector('.accordion')
        otherContent.removeAttribute("open");
      }
    }
  }); 
}

// #rg_custom
function addClassToSectionHeaders() {
    var categoryfc = document.querySelectorAll('.category__section');
    categoryfc.forEach(function(section) {
        var header = section.querySelector('h2');
        if (header) {
            header.classList.add('js-sect-header-active');
        }
    });
}

function addClassToSections() {
    var categoryfc = document.querySelectorAll('section:has(.category__section)');
    categoryfc.forEach(function(section) {
        section.classList.add('js-sect-header-active-sect');
    });
}
document.addEventListener('DOMContentLoaded', function() {
    addClassToSectionHeaders();
    addClassToSections();
});

// rg_custom @mikawaya
// const targetMikawayTitle = document.querySelector('#mikawaya-subscription-lines-coupon + p');
// if (targetMikawayTitle) {
//     targetMikawayTitle.textContent = '新タイトル';
// }